import type { VFC } from 'react'

import AttributePickerColor from './AttributePickers/AttributePickerColor'
import AttributePickerMultipleAttribute from './AttributePickers/AttributePickerMultipleAttribute'
import AttributePickerSingleAttribute from './AttributePickers/AttributePickerSingleAttribute'

import type { Variant } from './index'

interface AttributePickerProps {
  isSelected: boolean
  pickerValue: string
  id: string
  isInStock: boolean
  isMasterPage?: boolean
  isPersonal: boolean
  isSingle: boolean
  variant?: Variant
  isSingleAttributeProduct: boolean
  prescriptionType: string
  hasAdditionalCharge: boolean
  variantAttributeType: string
  packageSizeAttribute: boolean
}

export interface AttributePickers {
  pickerValue: string
  id: string
  styles: string
}

const AttributePicker: VFC<AttributePickerProps> = ({
  isSelected,
  pickerValue,
  id,
  isInStock,
  isMasterPage = false,
  isPersonal,
  isSingle,
  variant,
  isSingleAttributeProduct,
  prescriptionType,
  hasAdditionalCharge,
  variantAttributeType,
  packageSizeAttribute,
}) => {
  let styles = 'o-ProductVariantsAttributePicker'
  if (isSingle || (isSelected && (!isMasterPage || !isPersonal))) {
    styles += ' selectedVariantAttribute'
  }

  if (!isInStock && !isMasterPage) {
    styles = styles + ' grayedOutVariantAttribute'
  }

  if (isSingleAttributeProduct) {
    // return single variant attribute picker
    return (
      <AttributePickerSingleAttribute
        pickerValue={pickerValue}
        id={id}
        styles={styles}
        variant={variant}
        prescriptionType={prescriptionType}
        isSelected={isSelected}
        hasAdditionalCharge={hasAdditionalCharge}
        variantAttributeType={variantAttributeType}
        packageSizeAttribute={packageSizeAttribute}
      />
    )
  } else if (
    variantAttributeType.toLowerCase() === 'color' &&
    pickerValue.includes('#')
  ) {
    /// Return color picker
    return (
      <AttributePickerColor pickerValue={pickerValue} id={id} styles={styles} />
    )
  } else {
    ///return regular picker
    return (
      <AttributePickerMultipleAttribute
        pickerValue={pickerValue}
        id={id}
        styles={styles}
      />
    )
  }
}
export default AttributePicker
